import { render } from "./Infant.vue?vue&type=template&id=1e22d1b7"
import script from "./Infant.vue?vue&type=script&lang=js"
export * from "./Infant.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__